export enum PaginationDefinition {
	RESULTS_PER_PAGE = 20,
	DEFAULT_PAGE_NUMBER = 1,
}
